<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل وكيل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/agentview">وكلاء العقارية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل وكيل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center pt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown ms-2">
              <i class="bi bi-pencil-square me-2 text-brown"></i>تعديل وكيل
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="agentError" :alertMessage= "message" />
              </div>
              <div v-if="successAgent" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <form action="" @submit.prevent="agentUpdate">
                  <div class="row py-2">
                    <div class="col">
                      <label for="">تحميل الصورة</label>
                      <input type="file" class="form-control" @change.prevent="onFileAdd($event.target.files)">
                    </div>
                    <div class="col">
                      <div class="text-center">
                        <img :src="BASE_URL+'uploads/'+image" class="rounded-circle w-50" lt="">
                      </div>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">الاسم</label>
                      <input type="text" class="form-control" v-model="agentName">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">رقم الجوال</label>
                      <input type="text" class="form-control" v-model="phoneNumber">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="isLoading" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'agentupdate',
  data(){
    return {
      agentId: this.$route.params.id,
      agentError: false,
      message: '',
      agentName: "",
      isLoading: false,
      loader: false,
      status: true,
      successAgent: false,
      phoneNumber: "",
      image: "",
      rows: [],
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    getData(){
      this.agentError = false;
      this.loader = true;
      this.$http.get(`/api/admin/agents/retrieve/${this.agentId}`).then(res => {
        // console.log(res);
        this.loader = false;
        this.image = res.data.agent.avatar;
        this.agentName = res.data.agent.name;
        this.phoneNumber = res.data.agent.mobile;
        this.status = res.data.agent.isActive;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.agentError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
    agentUpdate(){
      this.agentError = false;
      this.successAgent = false;
      this.message = "";
      if(this.agentName == ""){
        this.message = 'يجب إدخال الاسم';
        this.agentError = true;
        return false;
      }
      const formData = new FormData();
      formData.append('name',this.agentName);
      formData.append('mobile',this.phoneNumber);
      formData.append('avatar',this.image);
      formData.append('isActive',this.status);
      this.isLoading = true;
      this.$http.put(`/api/admin/agents/update/${this.agentId}`,formData).then(res => {
        this.isLoading = false;
        this.message = 'تم التعديل بنجاح';
        this.successAgent = true;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.agentError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files) {
      this.image = files[0];
    }
  },
  created() {
    this.getData();
  }
}
</script>